export default __webpack_public_path__ + "static/media/filter.4a2d8949.svg";